import React, { Component, Fragment } from 'react';
import {
  Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, Button, Row
} from 'reactstrap';
import { change, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import BasicDataPatient from './BasicDataPatient/BasicDataPatient';
import HistoryForm from './HistoryResumen/HistoryForm';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import classnames from 'classnames';
import HistoryFormTwo from './HistoryResumen/HistoryFormTwo';
import ProcedureForm from './HistoryResumen/ProcedureForm'
import history from '../../../../history';
import HistoryFormThree from './HistoryResumen/HistoryFormThree';
import MioEscanografia from './HistoryResumen/MioEscanografia';
import Notes from '../../ClinicHistoryViewIPS/components/Notes/Notes';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import HistoryFormFour from './HistoryResumen/HistoryFormFour';
import PatientInformation from '../../PatientInformation/PatientInformation';

class TabsBorderedTop extends Component {

  constructor() {
    super();
    this.state = {
      btnActive: true,
      activeTab: '1',
      loadTab: false,
      profile: sessionStorage.getItem('perfil'),
      stateClinicistory: '',
      dataHistory: [],
      loading: true,
      plans: [],
      planName: '',
      idPlan: '',
      age: '',
      informes: {
        motivo_consulta: "",
        resultados: "",
        recomendaciones: "",
        descripcion: "",
        parametros: "",
        nota: "",
        conclusion: "",
        observaciones: "",
      },
      userPermits: [],
      refreshInfoPatient: {
        secondLastName: '',
        firstLastName: '',
        names: '',
        birthday: new Date(),
        documentNumber: '',
        typeOfDocument: '',
        age: ''
      },
      listTipos: JSON.parse(sessionStorage.getItem('centroTipos')),
    }
  }

  componentDidMount() {

    console.log("dataHistory", this.props.data);

    this.validatePermissionsClinicHistory();
    this.setState({ stateClinicistory: this.props.data.estado });
    this.loadDataTempletes();
    this.calculateAge(this.props.data.birthday);
    this.loadDataCita().then(() => {
      this.getDataHistory();
    });
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        typeOfDocument: this.props.data.tip_documento,
        /* birthday: this.props.data.birthday,
        documentNumber: this.props.data.num_documento, */
      }
    }
    )

  }

  handlerSecondLastNameDataInfo = (SecondLastName) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, secondLastName: SecondLastName } })
  }
  handlerFirstLastNameDataInfo = (FirstLastName) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, firstLastName: FirstLastName } })
  }
  handlerNamesDataInfo = (names) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, names: names } })
  }
  handlerBirthDateDataInfo = (birthday) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, ["birthday"]: birthday } },
      () => this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, ["birthday"]: birthday } }))
  }
  handlerAgeDataInfo = (age) => {
    this.setState({
      refreshInfoPatient: {
        ...this.state.refreshInfoPatient,
        age: age
      }
    });
  }
  handlerDocumentNumberDataInfo = (documentNumber) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, documentNumber: documentNumber } })
  }
  handlerTypeOfDocumentDataInfo = (typeOfDocument) => {
    this.setState({ refreshInfoPatient: { ...this.state.refreshInfoPatient, typeOfDocument: typeOfDocument } })
  }

  calculateAge = (birthday) => {
    //let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
    let hoy = new Date();
    let cumpleanos = new Date(birthday);

    let edad = hoy.getFullYear() - cumpleanos.getFullYear();

    let meses = hoy.getMonth() - cumpleanos.getMonth();


    if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
    }

    let cantMeses = meses;

    if (meses < 0) {
      cantMeses = 12 + meses;
    }

    let edadTotal = edad + ' años ' + cantMeses + ' meses';

    this.setState({ age: edadTotal });
  }


  loadDataTempletes = async () => {

    const id = sessionStorage.getItem('id_clinica');

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas/consultar?id_clinica=' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        if (data.plantilla !== null) {

          this.setState({
            informes: {
              motivo_consulta: data.plantilla.informes !== null ? data.plantilla.informes.motivo_consulta : "",
              resultados: data.plantilla.informes !== null ? data.plantilla.informes.resultados : "",
              recomendaciones: data.plantilla.informes !== null ? data.plantilla.informes.recomendaciones : "",
              descripcion: data.plantilla.informes !== null ? data.plantilla.informes.descripcion : "",
              observaciones: data.plantilla.informes !== null ? data.plantilla.informes.observaciones : "",
              conclusion: data.plantilla.informes !== null ? data.plantilla.informes.conclusion : "",
              nota: data.plantilla.informes !== null ? data.plantilla.informes.nota : "",
              parametros: data.plantilla.informes !== null ? data.plantilla.informes.parametros : "",
            },
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  getDataHistory = async () => {
    const id_historia = this.props.data.id_historia;
    const id_admision = this.props.data.id_admision;

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/consultar?id_historia=' + id_historia + '&id_admision=' + id_admision, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {

        if (response.status !== 500 && response.status !== 403) {

          return response.json();
        }
      })
      .then(data => {
        console.log(data);
        this.setState({ dataHistory: data, loading: false });

      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataCita = async () => {
    var data = { id_cita: this.props.data.id_cita };
    //id_agenda: this.props.dataEvent.id_agenda 
    //console.log(data);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultarpaciente', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data)
        if (data.existe) {
          this.setState({ idPlan: data.contenido.idPlan })
          this.getThirdAdmision(data.contenido.idCliente);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  getThirdAdmision = (id) => {

    fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },

    }).then(response => {
      return response.json();
    })
      .then(data => {
        console.log(data);
        this.setState({ planName: data.contenido[0].nombre })
        //this.setState({ third: data.contenido[0] })

      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  };

  validatePermissionsClinicHistory = () => {
    var user = JSON.parse(sessionStorage.getItem('usuario'));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        this.setState({ userPermits: perfil });
      } else {
        var perfil = [];
        this.setState({ userPermits: perfil });
      }
    } else {
      this.setState({ userPermits: [] });
    }
  }

  render() {
    const { activeTab } = this.state;

    return (
      <Col>
        {this.state.loading ?
          <div className="text-center">
            <Spinner animation="border" variant="success" />
          </div>
          :
          <Fragment>
            <Row>
              <Col md={2}>
                <h3 style={{ marginBottom: 30 }}>Historia Cliníca</h3>
                <Button
                  style={{ marginBottom: 20 }}
                  color="primary"
                  size="sm"
                  onClick={() => {
                    history.push({
                      pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                      state: {
                        date: this.props.data.fecha,
                        estado_list_form: this.props.data.estado_list_form,
                        pageIndex: this.props.pageIndex
                      }
                    });
                  }}
                > <ArrowBackIcon />
                </Button>
              </Col>
              <Col md={10}>
                <PatientInformation
                  num_documento={this.props.data.num_documento}
                  nombres={this.props.data.nombres}
                  tip_documento={this.props.data.tip_documento}
                  birthday={this.props.data.birthday}
                  remitente={this.props.data.remitente}
                  servicio={this.props.data.servicio}
                  refreshInfoPatient={this.state.refreshInfoPatient}
                  infoPatient={this.props.data}
                  id_admision={this.props.data.id_admision}
                />
              </Col>
            </Row>

            <Card>
              <CardBody>
                <div className="tabs tabs--bordered-top">
                  <div className="tabs__wrap">
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '1' })}
                          onClick={() => {
                            this.toggle('1');
                          }}
                        >
                          DATOS BÁSICOS
                        </NavLink>
                      </NavItem>


                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '2' })}
                          onClick={() => {
                            this.toggle('2');
                          }}
                        >
                          CONSULTA
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '3' })}
                          onClick={() => {
                            this.toggle('3');
                          }}
                        >
                          CONSULTA 2
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '4' })}
                          onClick={() => {
                            this.toggle('4');
                          }}
                        >
                          CONSULTA 3
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '5' })}
                          onClick={() => {
                            this.toggle('5');
                          }}
                        >
                          CONSULTA 4
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '6' })}
                          onClick={() => {
                            this.toggle('6');
                          }}
                        >
                          PROCEDIMIENTO
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '7' })}
                          onClick={() => {
                            this.toggle('7');
                          }}
                        >
                          MIOFUNCIONAL
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === '8' })}
                          onClick={() => {
                            this.toggle('8');
                          }}
                        >
                          NOTAS CLINICAS
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <BasicDataPatient
                          dataPatient={this.props.data !== undefined ? this.props.data : this.props.location.state.dataPatient.num_documento}
                          handlerDocumentNumberDataInfo={this.handlerDocumentNumberDataInfo}
                          handlerTypeOfDocumentDataInfo={this.handlerTypeOfDocumentDataInfo}
                          handlerNamesDataInfo={this.handlerNamesDataInfo}
                          handlerFirstLastNameDataInfo={this.handlerFirstLastNameDataInfo}
                          handlerSecondLastNameDataInfo={this.handlerSecondLastNameDataInfo}
                          handlerBirthDateDataInfo={this.handlerBirthDateDataInfo}
                          handlerAgeDataInfo={this.handlerAgeDataInfo}
                          refreshInfoPatient={this.state.refreshInfoPatient} /> {/*this.props.data.num_documento*/}
                        {/*  <BasicDataPatient num_documento={this.props.data !== undefined ? this.props.data.num_documento : this.props.location.state.dataPatient.num_documento} age={this.state.age} remitente={this.props.data.remitente} />  */}
                      </TabPane>
                      <TabPane tabId="2">
                        <HistoryForm data={this.props.data} age={this.state.age} planName={this.state.planName} dataHistory={this.state.dataHistory} history={this.state.informes} />
                      </TabPane>
                      <TabPane tabId="3">
                        <HistoryFormTwo data={this.props.data} age={this.state.age} planName={this.state.planName} dataHistory={this.state.dataHistory} history={this.state.informes} />
                      </TabPane>
                      <TabPane tabId="4">
                        <HistoryFormThree data={this.props.data} age={this.state.age} planName={this.state.planName} dataHistory={this.state.dataHistory} history={this.state.informes} />
                      </TabPane>
                      <TabPane tabId="5">
                        <HistoryFormFour data={this.props.data} age={this.state.age} planName={this.state.planName} dataHistory={this.state.dataHistory} history={this.state.informes} />
                      </TabPane>
                      <TabPane tabId="6">
                        <ProcedureForm data={this.props.data} age={this.state.age} planName={this.state.planName} dataHistory={this.state.dataHistory} history={this.state.informes} />
                      </TabPane>
                      <TabPane tabId="7">
                        <MioEscanografia data={this.props.data} age={this.state.age} planName={this.state.planName} dataHistory={this.state.dataHistory} history={this.state.informes} />
                      </TabPane>
                      <TabPane tabId="8">
                        <Notes data={this.props.data} />
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
                <div>
                </div>
              </CardBody>
            </Card>
          </Fragment>}
      </Col>
    );
  }

}

export default reduxForm({
  form: 'clinic_history_form', // a unique identifier for this form
})(withTranslation('common')(TabsBorderedTop));